// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GDunJzzgFqQY_3 {\n  margin: 0 4px 0 0;\n  transition: 0.1s ease;\n}\n.SoJoBusTiv7mde {\n  padding-left: 8px;\n}\n.board-wrapper.is-show-menu .GDunJzzgFqQY_3 {\n  display: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showSidebarButton": "GDunJzzgFqQY_3",
	"showSidebarButtonWithText": "SoJoBusTiv7mde"
};
export default ___CSS_LOADER_EXPORT___;
